/* global jQuery COMPONENTS google singleLocation singleMarker googleMapsStyler */

COMPONENTS.ComponentSingleLocationMap = (function ($) {
  function ComponentSingleLocationMap () {
    if (typeof singleLocation === 'undefined') {
      return
    }

    this.$component = $('[data-ecs-component="component-singlelocationmap"]')

    if (this.$component.length < 1) {
      // There is no asset map component on the page, bail out
      return
    }

    this.$mapElem = $('[data-ecs-components-control="single-location-map"]')

    this.map = null
    this.markers = []

    this.mapArgs = {
      scrollwheel: false,
      maxZoom: 20,
      minZoom: 4,
      disableDefaultUI: true,
      zoomControl: false,
      cameraControl: true,
      streetViewControl: true,
      gestureHandling: 'cooperative'
    }

    if (typeof googleMapsStyler !== 'undefined') {
      this.mapArgs.styles = googleMapsStyler
    }

    this.location = singleLocation
  }

  ComponentSingleLocationMap.prototype.init = function () {
    if (typeof singleLocation === 'undefined') {
      return
    }

    if (this.$component.length < 1) {
      // There is no asset map component on the page, bail out
      return
    }

    this.initMap()
  }

  ComponentSingleLocationMap.prototype.initMap = function () {
    this.map = new google.maps.Map(this.$mapElem.get(0), this.mapArgs)
    this.addMarkers()
  }

  ComponentSingleLocationMap.prototype.addMarkers = function (_location = this.location) {
    const component = this
    this.bounds = new google.maps.LatLngBounds()

    const markerItem = {}
    const propertyLatLng = new google.maps.LatLng(_location.lat, _location.lng)
    markerItem.propertyLatLng = propertyLatLng
    markerItem.map = this.map
    let markerToUse = ''

    if (typeof singleMarker !== 'undefined') {
      markerToUse = singleMarker
    }

    const marker = new google.maps.Marker({
      property: markerItem.property,
      position: markerItem.propertyLatLng,
      title: markerItem.title,
      icon: markerToUse,
      map: markerItem.map
    })

    component.bounds.extend(marker.position)
    component.markers.push(marker)

    this.map.setZoom(14)
    this.map.panTo(marker.position)
  }

  return ComponentSingleLocationMap
})(jQuery)

document.addEventListener('components_init', function () {
  // Hook into the main components init
  COMPONENTS.componentSingleLocationMap = new COMPONENTS.ComponentSingleLocationMap()

  if (window._ecsGoogleMapsLoaded) {
    COMPONENTS.componentSingleLocationMap.init()
  } else {
    document.addEventListener('ecs_googlemaps_ready', function () {
      COMPONENTS.componentSingleLocationMap.init()
    }, { once: true })
  }
})
